
import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Aviso } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class AvisoService extends BaseResourceService<Aviso> {

  constructor(
    protected injector: Injector
  ) {
    super(`avisos`, injector);
  }

}